module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-146.b5f94125.jpg";